import { render, staticRenderFns } from "./InvoiceWithActionsLayout.vue?vue&type=template&id=4b40cae8&scoped=true&lang=pug&"
import script from "./InvoiceWithActionsLayout.vue?vue&type=script&lang=js&"
export * from "./InvoiceWithActionsLayout.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceWithActionsLayout.vue?vue&type=style&index=0&id=4b40cae8&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b40cae8",
  null
  
)

export default component.exports